export default {
  setSurveyQuestions (state, payload) {
    state.questions = payload
  },
  setPracticeDetails (state, payload) {
    state.practiceDetails = payload
  },
}